/**
 * German messages of the operator area (F-69), merged into {@link messagesDe}. Further pages of the
 * area (F-70) add their messages here, so the dictionary of the application of the tenants stays
 * untouched.
 */
export const platformMessagesDe = {
  "platform.brand": "Zeitavo Betrieb",
  "platform.nav.main": "Navigation des Betreiberbereichs",
  "platform.nav.overview": "Übersicht",
  "platform.nav.tenants": "Mandanten",
  "platform.nav.onboarding": "Anlegen",
  "platform.nav.signups": "Registrierungen",
  "platform.nav.account": "Konto",
  "platform.status.Trial": "Testphase",
  "platform.status.Active": "Aktiv",
  "platform.status.PastDue": "Zahlung überfällig",
  "platform.status.Suspended": "Gesperrt",
  "platform.status.Terminated": "Gekündigt",
  "platform.status.ExportWindow": "Exportfrist",
  "platform.status.Deleted": "Gelöscht",
  "platform.isolation.Pool": "Gemeinsame Datenbank",
  "platform.isolation.Silo": "Eigene Datenbank",
  "platform.lifecycleReason.OperatorDecision": "Entscheidung des Betreibers",
  "platform.lifecycleReason.SubscriptionStarted": "Abonnement begonnen",
  "platform.lifecycleReason.PaymentFailed": "Zahlung fehlgeschlagen",
  "platform.lifecycleReason.PaymentReceived": "Zahlung eingegangen",
  "platform.lifecycleReason.DunningPeriodExpired": "Mahnfrist abgelaufen",
  "platform.lifecycleReason.ContractEnded": "Vertrag beendet",
  "platform.lifecycleReason.Reactivated": "Wieder aktiviert",
  "platform.lifecycleReason.ExportWindowExpired": "Exportfrist abgelaufen",
  "platform.overview.title": "Übersicht",
  "platform.overview.byStatus": "Mandanten nach Status",
  "platform.overview.noTenants": "Noch keine Mandanten.",
  "platform.overview.tenantCount.one": "1 Mandant",
  "platform.overview.tenantCount.other": "{count} Mandanten",
  "platform.overview.trialsEnding": "Testphasen, die bald enden",
  "platform.overview.noTrialsEnding": "Keine Testphase endet in den nächsten 7 Tagen.",
  "platform.overview.trialEndsOn": "endet am {date}",
  "platform.overview.pastDue": "Überfällige Zahlungen",
  "platform.overview.noPastDue": "Keine überfälligen Zahlungen.",
  "platform.overview.pastDueSince": "überfällig seit {date}",
  "platform.overview.failedSignups": "Registrierungen mit Fehler",
  "platform.overview.noFailedSignups": "Keine Registrierung mit Fehler.",
  "platform.overview.stalledOnboardings": "Hängende Einrichtungen",
  "platform.overview.noStalledOnboardings": "Keine hängende Einrichtung.",
  "platform.overview.requestedAt": "registriert am {date}",
  "platform.tenants.title": "Mandanten",
  "platform.tenants.count.one": "1 Mandant gefunden.",
  "platform.tenants.count.other": "{count} Mandanten gefunden.",
  "platform.tenants.caption": "Mandanten des Betreibers",
  "platform.tenants.empty": "Kein Mandant passt zu Suche und Filter.",
  "platform.tenants.none": "Noch keine Mandanten angelegt.",
  "platform.tenants.filter": "Mandanten suchen und filtern",
  "platform.tenants.search": "Name oder Kennung",
  "platform.tenants.allStatuses": "Alle Status",
  "platform.tenants.allPlans": "Alle Tarife",
  "platform.tenants.allDatabases": "Alle Datenbanken",
  "platform.tenant.title": "Mandant",
  "platform.tenant.back": "Zurück zu den Mandanten",
  "platform.tenant.name": "Name",
  "platform.tenant.status": "Status",
  "platform.tenant.plan": "Tarif",
  "platform.tenant.database": "Datenbank",
  "platform.tenant.createdAt": "Angelegt am",
  "platform.tenant.masterData": "Stammdaten",
  "platform.tenant.since": "seit {date}",
  "platform.tenant.trialEndsOn": "Testphase endet am",
  "platform.tenant.moving": "(Umzug in die Datenbank {key} läuft)",
  "platform.tenant.organization": "Organisation im Anmeldedienst",
  "platform.tenant.noOrganization": "Keine",
  "platform.tenant.id": "Kennung",
  "platform.tenant.onboarding": "Stand der Einrichtung ansehen",
  "platform.changes.title": "Tarif und Status ändern",
  "platform.changes.none":
    "Der Vertrag ist beendet; Tarif und Status ändern sich nur noch durch die Fristen.",
  "platform.change.reason": "Begründung",
  "platform.change.reasonHint":
    "Wird mit der Änderung im Plattform-Protokoll gespeichert. Bitte keine Daten von Beschäftigten des Kunden eintragen.",
  "platform.change.reasonBlank": "Bitte geben Sie eine Begründung ein, nicht nur Leerzeichen.",
  "platform.change.confirmName": "Name des Mandanten zur Bestätigung",
  "platform.change.confirmNameHint": "Geben Sie „{name}“ genau so ein.",
  "platform.change.nameMismatch": "Der Name stimmt nicht mit dem Namen des Mandanten überein.",
  "platform.change.statusDone": "Status geändert: {status}.",
  "platform.action.activate": "Aktivieren",
  "platform.action.activate.consequence":
    "Der Mandant wird aktiv. Aus der Exportfrist heraus wird die geplante Löschung abgebrochen. Dafür muss der Auftragsverarbeitungsvertrag in der geltenden Fassung angenommen sein.",
  "platform.action.mark-past-due": "Zahlung überfällig setzen",
  "platform.action.mark-past-due.consequence":
    "Die Administration des Mandanten sieht einen Hinweis auf die offene Zahlung; alle Funktionen bleiben nutzbar.",
  "platform.action.suspend": "Sperren",
  "platform.action.suspend.consequence":
    "Die Verwaltung des Mandanten wird schreibgeschützt. Stempeln, eigene Zeiten und Exporte funktionieren weiter.",
  "platform.action.terminate": "Kündigen",
  "platform.action.terminate.consequence":
    "Der Vertrag endet sofort und die Exportfrist beginnt. Danach werden die Daten des Mandanten gelöscht, wenn er nicht wieder aktiviert wird.",
  "platform.plan.change": "Tarif wechseln",
  "platform.plan.changed": "Tarif geändert: {plan}.",
  "platform.plan.new": "Neuer Tarif",
  "platform.plan.choose": "Tarif auswählen",
  "platform.plan.option": "{name} ({code})",
  "platform.lifecycle.title": "Statusänderungen",
  "platform.lifecycle.empty": "Noch keine Statusänderung.",
  "platform.lifecycle.change": "{from} → {to}",
  "platform.lifecycle.details": "{reason}, {at}, durch {actor}",
  "platform.usage.title": "Nutzung",
  "platform.usage.empty": "Noch keine gemessene Nutzung.",
  "platform.usage.month": "Monat",
  "platform.usage.active": "Aktive Beschäftigte",
  "platform.usage.employees": "Beschäftigte",
  "platform.contacts.title": "Ansprechpersonen",
  "platform.contacts.empty": "Der Mandant hat noch keine Ansprechpersonen hinterlegt.",
  "platform.legal.title": "Akzeptierte Rechtstexte",
  "platform.legal.empty": "Noch keine Entscheidung über Rechtstexte.",
  "platform.legal.Accepted": "{document}, Fassung {version}: angenommen am {at}",
  "platform.legal.Declined": "{document}, Fassung {version}: abgelehnt am {at}",
  "platform.protection.title": "Schutzbedarf",
  "platform.protection.none": "Der Schutzbedarf ist noch nicht eingeschätzt.",
  "platform.protection.result": "Schutzbedarf {need}; empfohlen: {isolation}.",
  "platform.protection.need.High": "hoch",
  "platform.protection.need.VeryHigh": "sehr hoch",
  "platform.protection.questions": "Fragen zum Schutzbedarf",
  "platform.protection.publicSector": "Öffentliche Stelle",
  "platform.protection.healthCare": "Gesundheitswesen",
  "platform.protection.criticalInfrastructure": "Kritische Infrastruktur",
  "platform.protection.employees": "Anzahl der Beschäftigten",
  "platform.protection.employeeCount.one": "1 Beschäftigte oder Beschäftigter",
  "platform.protection.employeeCount.other": "{count} Beschäftigte",
  "platform.protection.assess": "Schutzbedarf einschätzen",
  "platform.protection.save": "Einschätzung speichern",
  "platform.protection.saved": "Schutzbedarf gespeichert.",
  "platform.sso.title": "Single Sign-on",
  "platform.sso.none": "Kein Single Sign-on eingerichtet.",
  "platform.sso.configure": "Single Sign-on einrichten",
  "platform.sso.change": "Single Sign-on ändern",
  "platform.sso.save": "Single Sign-on speichern",
  "platform.sso.saved": "Single Sign-on gespeichert.",
  "platform.sso.protocol": "Protokoll",
  "platform.sso.protocol.Oidc": "OpenID Connect",
  "platform.sso.protocol.Saml": "SAML",
  "platform.sso.metadataUrl": "Adresse der Metadaten",
  "platform.sso.metadataUrlHint.Oidc":
    "Das Discovery-Dokument des Kunden, endet meist auf /.well-known/openid-configuration.",
  "platform.sso.metadataUrlHint.Saml": "Die Adresse der SAML-Metadaten des Kunden.",
  "platform.sso.clientId": "Client-Kennung beim Kunden",
  "platform.sso.clientSecret": "Client-Geheimnis",
  "platform.sso.clientSecretHint":
    "Bei jeder Änderung nötig; es wird weder gespeichert noch wieder angezeigt.",
  "platform.sso.domains": "E-Mail-Domains",
  "platform.sso.domainsHint":
    "Vorher geprüfte Domains des Kunden, getrennt durch Kommas, zum Beispiel kunde.de, kunde.com.",
  "platform.sso.configuredAt": "Eingerichtet am",
  "platform.emergency.title": "Notfallzugriffe",
  "platform.emergency.empty": "Noch kein Notfallzugriff angefragt.",
  "platform.emergency.item": "{status}: {hours} h, angefragt am {at}",
  "platform.emergency.validUntil": "Gültig bis {until}",
  "platform.emergency.status.Requested": "Wartet auf Freigabe",
  "platform.emergency.status.Approved": "Freigegeben",
  "platform.emergency.status.Rejected": "Abgelehnt",
  "platform.emergency.status.Revoked": "Widerrufen",
  "platform.emergency.request": "Notfallzugriff anfragen",
  "platform.emergency.requested":
    "Notfallzugriff angefragt; die Administration des Mandanten entscheidet.",
  "platform.emergency.reason": "Grund",
  "platform.emergency.reasonHint":
    "Die Administration des Mandanten sieht den Grund, zum Beispiel die Nummer der Supportanfrage.",
  "platform.emergency.hours": "Dauer in Stunden",
  "platform.emergency.requestedBy": "Ihr Name für den Mandanten",
  "platform.emergency.requestedByHint":
    "Die Administration des Mandanten sieht den Namen mit der Anfrage.",
  "platform.emergency.send": "Anfrage senden",
  "platform.onboarding.title": "Mandanten anlegen",
  "platform.onboarding.intro":
    "Legt Organisation, ersten Betrieb und die erste Administratorin oder den ersten Administrator an; die Einladung geht an die angegebene Adresse.",
  "platform.onboarding.customer": "Kunde",
  "platform.onboarding.tenantName": "Name des Unternehmens mit Rechtsform",
  "platform.onboarding.establishment": "Erster Betrieb",
  "platform.onboarding.establishmentName": "Name des Betriebs",
  "platform.onboarding.federalState": "Bundesland",
  "platform.onboarding.chooseState": "Bundesland auswählen",
  "platform.onboarding.timeZone": "Zeitzone",
  "platform.onboarding.timeZoneHint": "IANA-Zeitzone, in Deutschland Europe/Berlin.",
  "platform.onboarding.timeZoneInvalid": "Diese Zeitzone ist nicht bekannt.",
  "platform.onboarding.administrator": "Erste Administratorin oder erster Administrator",
  "platform.onboarding.email": "E-Mail-Adresse",
  "platform.onboarding.emailHint":
    "An diese Adresse geht die Einladung zum Festlegen des Passworts.",
  "platform.onboarding.firstName": "Vorname",
  "platform.onboarding.lastName": "Nachname",
  "platform.onboarding.database": "Datenbank",
  "platform.onboarding.databaseHint":
    "Bei sehr hohem Schutzbedarf ist eine eigene Datenbank nötig; sie muss im Betrieb eingerichtet sein.",
  "platform.onboarding.pool": "Gemeinsame Datenbank",
  "platform.onboarding.silo": "Eigene Datenbank {key}",
  "platform.onboarding.resume":
    "Senden Sie das Formular erneut, um die unterbrochene Einrichtung fortzusetzen.",
  "platform.onboarding.start": "Mandanten anlegen",
  "platform.onboarding.running": "Wird angelegt …",
  "platform.onboarding.started": "Einrichtung von {name} gestartet.",
  "platform.onboarding.statusTitle": "Stand der Einrichtung",
  "platform.onboarding.statusOf": "Einrichtung von {name}",
  "platform.onboarding.steps": "Schritte",
  "platform.onboarding.status.InProgress": "Unterbrochen oder läuft",
  "platform.onboarding.status.Completed": "Abgeschlossen",
  "platform.onboarding.status.RolledBack": "Zurückgerollt",
  "platform.onboarding.step.Started": "Anfrage angenommen",
  "platform.onboarding.step.OrganizationCreated": "Organisation im Anmeldedienst angelegt",
  "platform.onboarding.step.AdministratorCreated": "Administration angelegt",
  "platform.onboarding.step.TenantProvisioned": "Mandant mit Betrieb angelegt",
  "platform.onboarding.step.Registered": "Im Mandantenverzeichnis eingetragen",
  "platform.onboarding.stepDone": "erledigt",
  "platform.onboarding.stepOpen": "offen",
  "platform.onboarding.lastError": "Letzter Fehler: {error}",
  "platform.onboarding.times": "Begonnen am {started}, zuletzt geändert am {updated}.",
  "platform.onboarding.invitation": "Einladung",
  "platform.onboarding.invitationNotSent": "Die Einladung ist noch nicht verschickt.",
  "platform.onboarding.invitationSent": "Zuletzt verschickt am {at}.",
  "platform.onboarding.resend": "Einladung erneut senden",
  "platform.onboarding.resent": "Einladung erneut gesendet.",
  "platform.onboarding.openTenant": "Mandanten öffnen",
  "platform.signups.title": "Registrierungen",
  "platform.signups.intro":
    "Selbst registrierte Unternehmen. Ein Fehler beim Anlegen bleibt stehen, bis die Person den Bestätigungslink erneut öffnet.",
  "platform.signups.company": "Unternehmen",
  "platform.signups.contact": "Kontakt und Postleitzahl",
  "platform.signups.status": "Stand",
  "platform.signups.status.PendingVerification": "Wartet auf Bestätigung",
  "platform.signups.status.Completed": "Mandant angelegt",
  "platform.signups.status.Duplicate": "Bereits registriert",
  "platform.signups.requestedAt": "Registriert am",
  "platform.signups.lastError": "Letzter Fehler",
  "platform.signups.empty": "Noch keine Registrierungen.",
  "platform.account.title": "Konto",
  "platform.account.manage": "Rolle: Betrieb (ändern)",
  "platform.account.read": "Rolle: Support (nur lesen)",
  "platform.access.title": "Bereich konnte nicht geöffnet werden",
  "platform.access.text":
    "Die App fragt den Server, ob Ihr Konto zum Betreiberbereich gehört, und öffnet erst nach seiner Antwort den passenden Bereich.",
  "platform.access.offline":
    "Sie sind offline. Sobald eine Verbindung besteht, versucht es die App erneut.",
  "platform.unsent.one":
    "Auf diesem Gerät ist {count} Eintrag der Zeiterfassung noch nicht an den Server übertragen. Der Betreiberbereich überträgt ihn nicht; beim Abmelden wird er gelöscht.",
  "platform.unsent.other":
    "Auf diesem Gerät sind {count} Einträge der Zeiterfassung noch nicht an den Server übertragen. Der Betreiberbereich überträgt sie nicht; beim Abmelden werden sie gelöscht.",
  "platform.nav.billing": "Abrechnung",
  "platform.nav.legalDocuments": "Rechtstexte",
  "platform.nav.subprocessors": "Unterauftragsverarbeiter",
  "platform.nav.securityIncidents": "Sicherheitsvorfälle",
  "platform.nav.contractEnd": "Vertragsende",
  "platform.nav.databases": "Technik",
  "platform.overview.more": "Weitere Bereiche",
  "platform.tenant.billing": "Abrechnung ansehen",
  "platform.tenant.contractEnd": "Vertragsende ansehen",
  "platform.picker.title": "Mandant",
  "platform.picker.tenant": "Mandant",
  "platform.picker.choose": "Mandanten auswählen",
  "platform.picker.option": "{name} ({status})",
  "platform.billing.title": "Abrechnung",
  "platform.billing.intro":
    "Zahlungsstand, Rechnungen und Gutschriften eines Mandanten. Der Abgleich prüft alle Mandanten beim Zahlungsdienst.",
  "platform.billing.choose":
    "Wählen Sie einen Mandanten, um Zahlungsstand und Rechnungen zu sehen.",
  "platform.reconcile.title": "Abgleich mit dem Zahlungsdienst",
  "platform.reconcile.hint":
    "Vergleicht die Abos aller Mandanten mit dem Zahlungsdienst und übernimmt dessen Stand. Der Abgleich läuft auch jede Nacht.",
  "platform.reconcile.start": "Zahlungen abgleichen",
  "platform.reconcile.done": "Abgleich abgeschlossen.",
  "platform.reconcile.checked.one": "1 Mandant geprüft.",
  "platform.reconcile.checked.other": "{count} Mandanten geprüft.",
  "platform.reconcile.mismatches": "Abweichungen",
  "platform.reconcile.noMismatches": "Keine Abweichungen.",
  "platform.reconcile.failed": "Nicht abgeglichen: {tenants}",
  "platform.payment.title": "Zahlungsstand",
  "platform.payment.none": "Der Mandant hat kein Konto beim Zahlungsdienst.",
  "platform.payment.noSubscription": "Kein Abo",
  "platform.payment.status": "Abo",
  "platform.payment.plan": "Tarif beim Zahlungsdienst",
  "platform.payment.periodEnd": "Abrechnungszeitraum bis",
  "platform.payment.cancelAt": "Abo endet am",
  "platform.payment.method": "Zahlungsart",
  "platform.payment.customer": "Kundennummer beim Zahlungsdienst",
  "platform.payment.syncedAt": "Zuletzt abgeglichen",
  "platform.vat.title": "USt-IdNr.",
  "platform.vat.hint":
    "Prüft die USt-IdNr. aus dem Rechnungsprofil des Mandanten beim Prüfdienst der EU (VIES) und speichert die Bestätigung.",
  "platform.vat.check": "USt-IdNr. prüfen",
  "platform.vat.valid": "Gültig, bestätigt am {at} (Referenz {reference}).",
  "platform.vat.invalid": "Nicht bestätigt, geprüft am {at}.",
  "platform.vat.validShort": "USt-IdNr. bestätigt.",
  "platform.vat.invalidShort": "USt-IdNr. nicht bestätigt.",
  "platform.invoices.kind": "Art",
  "platform.invoices.actions": "Aktionen",
  "platform.creditNote.open": "Gutschrift zu {number}",
  "platform.creditNote.title": "Gutschrift zu {number} ausstellen",
  "platform.creditNote.reason": "Grund der Gutschrift",
  "platform.creditNote.reasonHint": "Steht auf der Gutschrift, die der Kunde erhält.",
  "platform.creditNote.amount": "Betrag netto in Euro",
  "platform.creditNote.amountHint":
    "Leer lassen, um den noch nicht gutgeschriebenen Rest der Rechnung gutzuschreiben.",
  "platform.creditNote.amountInvalid":
    "Bitte geben Sie einen Betrag größer als 0 ein, zum Beispiel 12,50.",
  "platform.creditNote.confirm":
    "Die Gutschrift erhält eine eigene Nummer, geht per E-Mail an den Kunden und lässt sich nicht zurücknehmen.",
  "platform.creditNote.issue": "Gutschrift ausstellen",
  "platform.creditNote.issued": "Gutschrift {number} ausgestellt.",
  "platform.legalDocuments.title": "Rechtstexte",
  "platform.legalDocuments.intro":
    "Veröffentlichte Fassungen von AGB, AVV, Service Level Agreement und Datenschutzhinweisen. Eine Fassung ist unveränderlich; ein Fehler im Text bedeutet eine neue Fassung.",
  "platform.legalDocuments.list": "Veröffentlichte Fassungen",
  "platform.legalDocuments.empty": "Noch keine Fassung veröffentlicht.",
  "platform.legalDocuments.new": "Neue Fassung veröffentlichen",
  "platform.legalDocuments.kind": "Dokument",
  "platform.legalDocuments.chooseKind": "Dokument auswählen",
  "platform.legalDocuments.version": "Fassung",
  "platform.legalDocuments.versionHint": "Bezeichnung der Fassung, zum Beispiel 2026-11.",
  "platform.legalDocuments.validFrom": "Gültig ab",
  "platform.legalDocuments.validFromHint":
    "Heute oder später (deutsche Zeit). Halten Sie die Ankündigungsfrist der Änderungsklausel ein.",
  "platform.legalDocuments.documentRef": "Ort des Textes",
  "platform.legalDocuments.documentRefHint":
    "Eine https-Adresse oder ein Pfad der Website, der mit / beginnt, zum Beispiel /legal/avv-2026-11.pdf.",
  "platform.legalDocuments.file": "Datei für die Prüfsumme",
  "platform.legalDocuments.fileHint":
    "Wählen Sie genau die veröffentlichte Datei; die Prüfsumme wird in Ihrem Browser gebildet, die Datei wird nicht hochgeladen.",
  "platform.legalDocuments.fileFailed":
    "Die Datei konnte nicht gelesen werden. Bilden Sie die Prüfsumme mit sha256sum und tragen Sie sie ein.",
  "platform.legalDocuments.contentHash": "Prüfsumme (SHA-256)",
  "platform.legalDocuments.contentHashHint":
    "64 Zeichen aus 0–9 und a–f, wie sha256sum sie ausgibt.",
  "platform.legalDocuments.showPreview": "Vorschau anzeigen",
  "platform.legalDocuments.preview": "Vorschau der neuen Fassung",
  "platform.legalDocuments.consequence.accept":
    "Ab {date} sehen die Administrationen aller Mandanten diese Fassung nach der Anmeldung und nehmen sie an oder lehnen sie ab.",
  "platform.legalDocuments.consequence.inform":
    "Ab {date} gilt diese Fassung; sie dient nur der Information, eine Zustimmung ist nicht nötig.",
  "platform.legalDocuments.confirm":
    "Ich habe Text, Prüfsumme und Datum geprüft. Die Fassung lässt sich nach der Veröffentlichung nicht mehr ändern.",
  "platform.legalDocuments.publish": "Veröffentlichen",
  "platform.legalDocuments.validFromPast":
    "„Gültig ab“ liegt vor dem heutigen Tag (deutsche Zeit). Gehen Sie zurück zur Eingabe und wählen Sie heute oder später.",
  "platform.legalDocuments.back": "Zurück zur Eingabe",
  "platform.legalDocuments.published": "{document}, Fassung {version}, veröffentlicht.",
  "platform.legalDocuments.acceptance": "Zustimmung",
  "platform.legalDocuments.mustAccept": "nötig",
  "platform.legalDocuments.informOnly": "nur Information",
  "platform.subprocessors.title": "Unterauftragsverarbeiter",
  "platform.subprocessors.intro":
    "Das Verzeichnis, das Kunden sehen, mit angekündigten Änderungen und Verlauf. Jede Änderung wird allen Mandanten angekündigt; sie gilt frühestens nach der Widerspruchsfrist.",
  "platform.subprocessors.current": "Aktuell",
  "platform.subprocessors.upcoming": "Angekündigt",
  "platform.subprocessors.history": "Verlauf",
  "platform.subprocessors.noneCurrent": "Keine Unterauftragsverarbeiter eingetragen.",
  "platform.subprocessors.noneUpcoming": "Keine Änderung angekündigt.",
  "platform.subprocessors.noneHistory": "Noch kein Verlauf.",
  "platform.subprocessors.kind.Added": "neu",
  "platform.subprocessors.kind.Changed": "geändert",
  "platform.subprocessors.kind.Removed": "entfernt",
  "platform.subprocessors.name": "Name des Unternehmens",
  "platform.subprocessors.purpose": "Zweck",
  "platform.subprocessors.dataCategories": "Datenkategorien",
  "platform.subprocessors.dataCategoriesHint":
    "Welche personenbezogenen Daten der Unterauftragsverarbeiter erhält.",
  "platform.subprocessors.location": "Ort der Verarbeitung",
  "platform.subprocessors.transferSafeguard": "Garantie für ein Drittland",
  "platform.subprocessors.transferSafeguardHint":
    "Zum Beispiel Standardvertragsklauseln; leer lassen bei Verarbeitung nur in der EU.",
  "platform.subprocessors.euOnly": "Verarbeitung nur in der EU",
  "platform.subprocessors.effectiveFrom": "Gilt ab",
  "platform.subprocessors.effectiveFromHint":
    "Frühestens nach der Widerspruchsfrist von mindestens 30 Tagen ab heute.",
  "platform.subprocessors.announcedAt": "Angekündigt am",
  "platform.subprocessors.add": "Unterauftragsverarbeiter hinzufügen",
  "platform.subprocessors.change": "{name} ändern",
  "platform.subprocessors.remove": "{name} entfernen",
  "platform.subprocessors.confirmAnnouncement":
    "Alle Mandanten werden per E-Mail benachrichtigt und können innerhalb der Frist widersprechen.",
  "platform.subprocessors.announce": "Änderung ankündigen",
  "platform.subprocessors.announced": "Änderung von {name} angekündigt.",
  "platform.subprocessors.removedFrom": "Nicht mehr beauftragt ab",
  "platform.subprocessors.removedFromHint": "Heute oder später.",
  "platform.subprocessors.removedFromPast":
    "Das Datum liegt vor dem heutigen Tag. Wählen Sie heute oder später.",
  "platform.subprocessors.effectiveFromTooEarly":
    "Das Datum liegt in der Widerspruchsfrist. Wählen Sie einen späteren Tag.",
  "platform.subprocessors.confirmRemoval":
    "Alle Mandanten werden per E-Mail benachrichtigt, dass der Unterauftragsverarbeiter nicht mehr beauftragt ist.",
  "platform.subprocessors.removeConfirm": "Entfernen ankündigen",
  "platform.subprocessors.removed": "Ende der Beauftragung von {name} angekündigt.",
  "platform.subprocessors.showNotices": "Versand an Mandanten: {name}",
  "platform.subprocessors.notices": "Versand an die Mandanten",
  "platform.subprocessors.noNotices": "Noch keine Benachrichtigung.",
  "platform.subprocessors.notice.tenant": "Mandant",
  "platform.subprocessors.notice.recipient": "Empfänger",
  "platform.subprocessors.notice.status": "Stand",
  "platform.subprocessors.notice.status.Pending": "wird versendet",
  "platform.subprocessors.notice.status.Sent": "versendet",
  "platform.subprocessors.notice.status.NoRecipient": "keine Adresse",
  "platform.subprocessors.notice.sentAt": "Versendet am",
  "platform.subprocessors.notice.notSent": "noch nicht versendet",
  "platform.subprocessors.notice.attempts.one": "1 Fehlversuch",
  "platform.subprocessors.notice.attempts.other": "{count} Fehlversuche",
  "platform.incidents.title": "Sicherheitsvorfälle",
  "platform.incidents.intro":
    "Meldung einer Verletzung des Schutzes personenbezogener Daten an einen Mandanten als Auftragsverarbeiter, unverzüglich nach Bekanntwerden (Art. 33 Abs. 2 DSGVO). Vorgehen nach dem Notfallplan für Sicherheitsvorfälle.",
  "platform.incidents.choose": "Wählen Sie den betroffenen Mandanten.",
  "platform.incidents.form": "Meldung an den Mandanten",
  "platform.incidents.detectedOn": "Bekannt geworden am",
  "platform.incidents.detectedAt": "Uhrzeit",
  "platform.incidents.description": "Was ist passiert?",
  "platform.incidents.descriptionHint": "Art der Verletzung, Zeitraum und betroffene Systeme.",
  "platform.incidents.dataCategories": "Betroffene Daten und Personen",
  "platform.incidents.dataCategoriesHint":
    "Kategorien und ungefähre Zahl der betroffenen Personen und Datensätze.",
  "platform.incidents.consequences": "Wahrscheinliche Folgen",
  "platform.incidents.consequencesHint":
    "Was die Verletzung für die betroffenen Personen bedeuten kann.",
  "platform.incidents.measures": "Ergriffene und vorgeschlagene Maßnahmen",
  "platform.incidents.measuresHint": "Was der Betreiber getan hat und was der Kunde tun sollte.",
  "platform.incidents.contactEmail": "Adresse für Rückfragen",
  "platform.incidents.contactEmailHint":
    "Zum Beispiel die Adresse der oder des Datenschutzbeauftragten des Betreibers.",
  "platform.incidents.consequence":
    "Die Meldung geht per E-Mail an die Ansprechperson für Sicherheit von {name}, ohne sie an die für Datenschutz oder Vertrag. Das Plattform-Protokoll hält fest, was gemeldet wurde.",
  "platform.incidents.send": "Meldung senden",
  "platform.incidents.sent": "Meldung an {name} in den Versand gegeben.",
  "platform.incidents.queued": "In den Versand gegeben am {at}.",
  "platform.contractEnd.title": "Vertragsende",
  "platform.contractEnd.intro":
    "Gekündigte Mandanten, ihre Exportfrist und die Löschung. Nach Ablauf der Exportfrist löscht der Nachtlauf die Daten; hier lässt sich die Löschung auch sofort auslösen.",
  "platform.contractEnd.list": "Mandanten nach Vertragsende",
  "platform.contractEnd.empty": "Kein Mandant mit beendetem Vertrag.",
  "platform.contractEnd.since": "Status seit",
  "platform.contractEnd.details": "Einzelheiten",
  "platform.contractEnd.show": "Vertragsende von {name}",
  "platform.contractEnd.of": "Vertragsende von {name}",
  "platform.contractEnd.noWindow": "Die Exportfrist ist noch nicht geöffnet.",
  "platform.contractEnd.scheduledAt": "Exportfrist geöffnet am",
  "platform.contractEnd.deleteAfter": "Löschung frühestens am",
  "platform.contractEnd.deletedAt": "Gelöscht am",
  "platform.contractEnd.report": "Löschprotokoll: gelöschte Einträge je Tabelle",
  "platform.contractEnd.table": "Tabelle",
  "platform.contractEnd.rows": "Einträge",
  "platform.contractEnd.waiting":
    "Die Exportfrist läuft bis {date}; danach löscht der Nachtlauf die Daten.",
  "platform.contractEnd.openWindow": "Exportfrist öffnen",
  "platform.contractEnd.openWindowConsequence":
    "Der Kunde wird informiert und kann seine Daten bis zur Löschung exportieren.",
  "platform.contractEnd.days": "Dauer der Exportfrist in Tagen",
  "platform.contractEnd.daysHint": "{min} bis {max} Tage.",
  "platform.contractEnd.windowOpened": "Exportfrist für {name} geöffnet.",
  "platform.contractEnd.purge": "Endgültig löschen",
  "platform.contractEnd.purgeConsequence":
    "Alle Daten des Mandanten werden endgültig gelöscht, auch die Konten im Anmeldedienst, die kein anderer Mandant nutzt. Das lässt sich nicht rückgängig machen. Es bleibt nur das Löschprotokoll.",
  "platform.contractEnd.secondFactor":
    "Die Löschung verlangt eine Anmeldung mit zweitem Faktor in den letzten 10 Minuten.",
  "platform.contractEnd.signInAgain":
    "Bitte melden Sie sich erneut mit Passwort und Einmalcode an. Danach kehren Sie hierher zurück und bestätigen die Löschung noch einmal.",
  "platform.contractEnd.signIn": "Erneut anmelden",
  "platform.contractEnd.purged": "{name} wurde gelöscht.",
  "platform.databases.title": "Technik",
  "platform.databases.intro":
    "Datenbanken der Mandanten, Umzug in eine eigene Datenbank und Rotation der Schlüssel. Beides hält das Plattform-Protokoll mit Begründung fest.",
  "platform.databases.list": "Datenbanken",
  "platform.databases.key": "Datenbank",
  "platform.databases.tenants": "Mandanten",
  "platform.databases.configured": "Im Betrieb eingerichtet",
  "platform.databases.isConfigured": "ja",
  "platform.databases.missing": "nein",
  "platform.databases.choose": "Wählen Sie einen Mandanten für Umzug oder Schlüsselrotation.",
  "platform.databases.move": "Umzug in eine eigene Datenbank",
  "platform.databases.inSilo": "Der Mandant liegt bereits in der eigenen Datenbank {key}.",
  "platform.databases.noSilo": "Im Betrieb ist keine eigene Datenbank eingerichtet.",
  "platform.databases.moveConsequence":
    "Die Daten werden kopiert, der Mandant wird umgeleitet und seine Einträge in der gemeinsamen Datenbank werden gelöscht. Schreibzugriffe warten während des Umzugs.",
  "platform.databases.ownConsequence":
    "Zeitavo legt auf dem Server eine eigene Datenbank für diesen Mandanten an, bringt sie auf den aktuellen Stand und zieht den Mandanten um: Die Daten werden kopiert, der Mandant wird umgeleitet und seine Einträge in der gemeinsamen Datenbank werden gelöscht. Schreibzugriffe warten während des Umzugs.",
  "platform.databases.ownStart": "Eigene Datenbank einrichten und umziehen",
  "platform.databases.target": "Ziel",
  "platform.databases.chooseTarget": "Datenbank auswählen",
  "platform.databases.moveStart": "Umzug starten",
  "platform.databases.moved": "{name} liegt jetzt in der Datenbank {key}.",
  "platform.databases.copied.one": "1 Eintrag kopiert.",
  "platform.databases.copied.other": "{count} Einträge kopiert.",
  "platform.databases.purged.one": "1 Eintrag aus der gemeinsamen Datenbank gelöscht.",
  "platform.databases.purged.other": "{count} Einträge aus der gemeinsamen Datenbank gelöscht.",
  "platform.databases.rotate": "Schlüssel rotieren",
  "platform.databases.rotateConsequence":
    "Ein neuer Datenschlüssel verschlüsselt die geschützten Werte des Mandanten neu. Der bisherige Schlüssel bleibt zum Lesen älterer Sicherungen erhalten.",
  "platform.databases.rotateStart": "Schlüssel rotieren",
  "platform.databases.rotated": "Neue Schlüsselversion {version}.",
  "platform.databases.rotationReport.one": "Schlüsselversion {version}, 1 Wert neu verschlüsselt.",
  "platform.databases.rotationReport.other":
    "Schlüsselversion {version}, {count} Werte neu verschlüsselt.",
  "platform.nav.auditLog": "Protokoll",
  "platform.nav.plans": "Pläne",
  "platform.nav.systemStatus": "Systemstatus",
  "platform.nav.staffAccounts": "Betriebskonten",
  "platform.tenant.auditLog": "Plattform-Protokoll ansehen",
  "platform.audit.title": "Plattform-Protokoll",
  "platform.audit.intro":
    "Alle Änderungen durch Betriebspersonal und durch die Abläufe der Plattform, die neuesten zuerst. Angezeigt wird nur der freigegebene Teil der Angaben: keine Namen von Kunden, keine Kennungen beim Zahlungsdienst, keine Texte von Datenpannen-Meldungen.",
  "platform.audit.filter": "Protokoll filtern",
  "platform.audit.allTenants": "Alle Mandanten",
  "platform.audit.actor": "Person oder Systemnutzer",
  "platform.audit.actorHint":
    "Kennung des Kontos (Vorschläge nach Benutzername) oder ein Systemnutzer wie system:dunning.",
  "platform.audit.from": "Von",
  "platform.audit.to": "Bis einschließlich",
  "platform.audit.show": "Anzeigen",
  "platform.audit.reset": "Filter zurücksetzen",
  "platform.audit.entries": "Einträge",
  "platform.audit.empty": "Kein Eintrag passt zu den Filtern.",
  "platform.audit.older": "Ältere Einträge laden",
  "platform.audit.tenant": "Mandant",
  "platform.audit.wholePlatform": "Ganze Plattform",
  "platform.audit.comment": "Begründung",
  "platform.audit.details": "Angaben",
  "platform.plans.title": "Pläne",
  "platform.plans.intro":
    "Alle Versionen aller Pläne mit ihrem Stand heute. Gespeicherte Versionen ändern sich nie: Preise, Sichtbarkeit und Funktionen ändert eine neue Version ab einem späteren Tag.",
  "platform.plans.versions": "Versionen",
  "platform.plans.noVersions": "Noch keine Planversion.",
  "platform.plans.caption": "{name} ({code})",
  "platform.plans.validFrom": "Gültig ab",
  "platform.plans.state": "Stand",
  "platform.plans.state.Past": "Abgelöst",
  "platform.plans.state.Current": "Gilt",
  "platform.plans.state.Scheduled": "Geplant",
  "platform.plans.name": "Name",
  "platform.plans.code": "Plancode",
  "platform.plans.codeHint":
    "Kleinbuchstaben, Ziffern und Bindestrich, am Anfang ein Buchstabe. Ein neuer Code legt einen neuen Plan an.",
  "platform.plans.public": "Öffentlich",
  "platform.plans.yes": "ja",
  "platform.plans.no": "nein",
  "platform.plans.basePrice": "Grundpreis netto im Monat",
  "platform.plans.pricePerEmployee": "Preis je aktiver Person netto im Monat",
  "platform.plans.setupFee": "Einrichtungsgebühr netto einmalig",
  "platform.plans.priceHint": "In Euro, zum Beispiel 0 oder 12,50.",
  "platform.plans.priceInvalid":
    "Bitte geben Sie einen Betrag von 0 bis 100.000 Euro ein, zum Beispiel 12,50.",
  "platform.plans.employeeLimit": "Personen inklusive",
  "platform.plans.employeeLimitHint": "Leer lassen für unbegrenzt.",
  "platform.plans.unlimited": "unbegrenzt",
  "platform.plans.entitlements": "Funktionen",
  "platform.plans.noEntitlements": "Nur Grundfunktionen",
  "platform.plans.isPublic": "Öffentlich: Kunden können den Plan selbst wählen",
  "platform.plans.addPlan": "Neuen Plan anlegen",
  "platform.plans.addVersion": "Neue Version von {name}",
  "platform.plans.consequence":
    "Die Version gilt ab ihrem ersten Tag für alle Mandanten mit diesem Plan, auch für bestehende Kunden, und lässt sich danach nicht mehr ändern. Planen Sie Preiserhöhungen mit der Ankündigungsfrist der AGB.",
  "platform.plans.validFromHint":
    "Nach heute und nach der letzten Version des Plans, frühestens am {date}.",
  "platform.plans.reduction":
    "Diese Version enthält weniger Funktionen oder Personen als die letzte Version des Plans. Bis zur rechtlichen Klärung legen Sie dafür einen neuen Plancode an.",
  "platform.plans.confirm": "Ich habe Preise, Funktionen und den ersten Tag geprüft.",
  "platform.plans.create": "Version anlegen",
  "platform.plans.created": "Version {name} ab {date} angelegt.",
  "platform.plans.prices": "Abgleich mit den Online-Preisen",
  "platform.plans.pricesIntro":
    "Vergleich der Pläne mit den Preisen, die online gekauft werden können (Payments:Prices). Die Beträge beim Zahlungsdienst prüfen Sie dort.",
  "platform.plans.priceId": "Grundgebühr beim Zahlungsdienst",
  "platform.plans.perEmployeePriceId": "Preis je Beschäftigtem",
  "platform.plans.setupPriceId": "Einrichtung",
  "platform.plans.noPriceId": "keiner",
  "platform.plans.findings": "Abweichungen",
  "platform.plans.noFindings": "Keine",
  "platform.plans.noPrices": "Keine Pläne und keine Preise eingerichtet.",
  "platform.plans.finding.PublicWithoutPrice": "Öffentlich, aber ohne Preis: nicht online kaufbar",
  "platform.plans.finding.PriceForPlanOnRequest": "Nur auf Anfrage, aber mit Preis: online kaufbar",
  "platform.plans.finding.PriceWithoutPlan": "Preis für einen Code ohne geltende Version",
  "platform.plans.finding.PerEmployeePriceMissing":
    "Kein Preis je Beschäftigtem: aktive Beschäftigte werden nicht berechnet",
  "platform.plans.finding.SetupPriceMissing":
    "Einrichtungsgebühr ohne Preis beim Zahlungsdienst: wird nicht berechnet",
  "platform.plans.finding.SetupPriceWithoutFee":
    "Preis für die Einrichtung, aber die Version hat keine Einrichtungsgebühr",
  "platform.plans.finding.BasePriceDiffers":
    "Grundgebühr beim Zahlungsdienst weicht vom Katalog ab (Betrag, Währung, Art oder inaktiv)",
  "platform.plans.finding.PerEmployeePriceDiffers":
    "Preis je Beschäftigtem beim Zahlungsdienst weicht vom Katalog ab (Betrag, Währung, Art oder inaktiv)",
  "platform.plans.finding.SetupPriceDiffers":
    "Einrichtungspreis beim Zahlungsdienst weicht vom Katalog ab (Betrag, Währung, Art oder inaktiv)",
  "platform.plans.finding.ProviderPriceUnavailable":
    "Ein Preis ließ sich beim Zahlungsdienst nicht lesen (unbekannt oder keine Antwort)",
  "platform.trial.title": "Testphase",
  "platform.trial.endsOn": "Endet am",
  "platform.trial.regularEndsOn": "Reguläres Ende",
  "platform.trial.extensions": "Verlängerungen",
  "platform.trial.extensionCount": "{done} bisher, noch {left} möglich",
  "platform.trial.latestEndsOn": "Spätestes Ende",
  "platform.trial.notExtendable": "Die Testphase lässt sich nicht weiter verlängern.",
  "platform.trial.extend": "Testphase verlängern",
  "platform.trial.consequence":
    "Das neue Ende gilt sofort. Der Kunde wird vor dem neuen Ende erneut erinnert.",
  "platform.trial.newEnd": "Neuer letzter Tag",
  "platform.trial.newEndHint": "Frühestens {earliest}, spätestens {latest}.",
  "platform.trial.extended": "Testphase verlängert bis {date}.",
  "platform.system.title": "Systemstatus",
  "platform.system.intro":
    "Hintergrundaufgaben, geplante Abläufe, E-Mail-Ausgang, Migrationen und die rechtliche Prüfung. Ohne Mandanten und ohne personenbezogene Daten.",
  "platform.system.checkedAt": "Stand: {date}",
  "platform.system.refresh": "Aktualisieren",
  "platform.system.never": "nie",
  "platform.system.jobs": "Hintergrundaufgaben",
  "platform.system.jobWindow": "Aller Mandanten seit {date} (7 Tage).",
  "platform.system.unreachable.one": "1 Datenbank hat nicht geantwortet.",
  "platform.system.unreachable.other": "{count} Datenbanken haben nicht geantwortet.",
  "platform.system.kind": "Art",
  "platform.system.lastSucceeded": "Zuletzt erfolgreich",
  "platform.system.lastFailed": "Zuletzt fehlgeschlagen",
  "platform.system.failed": "Endgültig fehlgeschlagen",
  "platform.system.retrying": "Warten auf Wiederholung",
  "platform.system.noJobs": "Keine Hintergrundaufgaben in den letzten 7 Tagen.",
  "platform.system.workers": "Geplante Abläufe",
  "platform.system.worker": "Ablauf",
  "platform.system.lastRun": "Letzter Lauf",
  "platform.system.noWorkers": "Noch kein Lauf erfasst.",
  "platform.system.outbox": "E-Mail-Ausgang",
  "platform.system.pending": "Wartend",
  "platform.system.givenUp": "Aufgegeben",
  "platform.system.oldestPending": "Älteste wartende seit",
  "platform.system.schemas": "Migrationen",
  "platform.system.database": "Datenbank",
  "platform.system.schemaStatus": "Stand",
  "platform.system.schema.Current": "Aktuell",
  "platform.system.schema.Outdated": "Veraltet",
  "platform.system.schema.Unreachable": "Nicht erreichbar",
  "platform.system.pendingMigrations": "Fehlende Migrationen",
  "platform.system.legalReview": "Rechtliche Prüfung",
  "platform.system.register": "Geltungsverzeichnis {version}, zuletzt geprüft am {date}.",
  "platform.system.procedure": "Gesetzgebungsverfahren",
  "platform.system.checkedOn": "Geprüft am",
  "platform.system.nextReviewBy": "Nächste Prüfung bis",
  "platform.system.overdue": "überfällig seit {date}",
  "platform.system.lastResult": "Ergebnis",
  "platform.system.unchanged": "unverändert",
  "platform.system.changed": "geändert",
  "platform.system.noProcedures": "Kein offenes Gesetzgebungsverfahren.",
  "platform.staff.title": "Betriebskonten",
  "platform.staff.intro":
    "Konten mit einer Plattformrolle, bei jedem Aufruf aus dem Anmeldedienst gelesen und nicht gespeichert. Konten legen Sie in der Verwaltungskonsole des Anmeldedienstes an und weisen dort die Rollen zu.",
  "platform.staff.list": "Konten",
  "platform.staff.username": "Benutzername",
  "platform.staff.roles": "Rollen",
  "platform.staff.role.PlatformAdmin": "Betrieb (ändern)",
  "platform.staff.role.PlatformSupport": "Support (nur lesen)",
  "platform.staff.enabled": "Anmeldung",
  "platform.staff.active": "aktiv",
  "platform.staff.disabled": "gesperrt",
  "platform.staff.secondFactor": "Zweiter Faktor",
  "platform.staff.secondFactorSet": "eingerichtet",
  "platform.staff.secondFactorMissing": "fehlt, wird bei der nächsten Anmeldung verlangt",
  "platform.staff.console": "Konsole",
  "platform.staff.openAccount": "{name} in der Konsole öffnen",
  "platform.staff.openConsole": "Verwaltungskonsole öffnen",
  "platform.staff.tunnel": "Nur über den Admin-Tunnel erreichbar.",
  "platform.staff.noConsole": "Der Link zur Verwaltungskonsole ist im Betrieb nicht eingerichtet.",
  "platform.staff.empty": "Kein Konto hat eine Plattformrolle.",
  "error.TT-1016":
    "Für diesen Unterauftragsverarbeiter ist bereits eine Änderung angekündigt. Warten Sie, bis sie gilt.",
  "error.TT-3025": "Das geht erst, wenn der Vertrag beendet und die Exportfrist abgelaufen ist.",
  "error.TT-3029":
    "Die Zieldatenbank hat ein anderes Schema oder enthält bereits Daten dieses Mandanten.",
  "error.TT-3039":
    "Eine Fassung mit dieser Bezeichnung oder diesem Datum ist bereits mit anderem Inhalt veröffentlicht. Veröffentlichen Sie eine neue Fassung.",
  "error.TT-3057": "Die Gutschrift übersteigt den noch nicht gutgeschriebenen Betrag der Rechnung.",
  "error.TT-3061":
    "Der Mandant hat keine Adresse für Mitteilungen. Informieren Sie den Kunden auf anderem Weg.",
  "error.TT-3490":
    "Für diesen Schritt ist eine Anmeldung mit zweitem Faktor in den letzten 10 Minuten nötig. Bitte melden Sie sich erneut an.",
  "error.TT-3015": "Dieser Mandant ist bereits eingetragen.",
  "error.TT-3019":
    "Single Sign-on ist nicht möglich: Der Mandant ist gekündigt oder hat keine Organisation im Anmeldedienst.",
  "error.TT-3020": "Eine der E-Mail-Domains gehört bereits zu einem anderen Mandanten.",
  "error.TT-3027": "Diese eigene Datenbank ist im Betrieb nicht eingerichtet.",
  "error.TT-3028":
    "Auf diesem Server werden keine eigenen Datenbanken angelegt. Richten Sie die Datenbank im Betrieb ein und wählen Sie sie als Ziel.",
  "error.TT-3033":
    "Bei sehr hohem Schutzbedarf muss der Mandant in einer eigenen Datenbank angelegt werden.",
  "platform.auditAction.Tenant.Registered": "Mandant eingetragen",
  "platform.auditAction.Tenant.PlanChanged": "Plan gewechselt",
  "platform.auditAction.Tenant.ProtectionAssessed": "Schutzbedarf eingeschätzt",
  "platform.auditAction.Tenant.Active": "Status „Aktiv“",
  "platform.auditAction.Tenant.PastDue": "Status „Zahlung überfällig“",
  "platform.auditAction.Tenant.Suspended": "Status „Gesperrt“",
  "platform.auditAction.Tenant.Terminated": "Status „Gekündigt“",
  "platform.auditAction.Tenant.ExportWindow": "Status „Exportfrist“",
  "platform.auditAction.Tenant.Deleted.Status": "Status „Gelöscht“",
  "platform.auditAction.Tenant.Deleted": "Mandant gelöscht",
  "platform.auditAction.Tenant.IdentitiesDeleted": "Konten im Anmeldedienst gelöscht",
  "platform.auditAction.Tenant.OrganizationDeleted": "Organisation im Anmeldedienst gelöscht",
  "platform.auditAction.Tenant.OffboardingScheduled": "Vertragsende eingeplant",
  "platform.auditAction.Tenant.OffboardingCancelled": "Vertragsende zurückgenommen",
  "platform.auditAction.Tenant.ExportWindowNotice": "Hinweis zur Exportfrist gesendet",
  "platform.auditAction.Tenant.SingleSignOnConfigured": "Firmenanmeldung eingerichtet",
  "platform.auditAction.Tenant.SingleSignOnRemoved": "Firmenanmeldung entfernt",
  "platform.auditAction.Tenant.MoveStarted": "Umzug in eigene Datenbank begonnen",
  "platform.auditAction.Tenant.MoveAborted": "Umzug in eigene Datenbank abgebrochen",
  "platform.auditAction.Tenant.MovedToSilo": "In eigene Datenbank umgezogen",
  "platform.auditAction.Tenant.KeyRotated": "Schlüssel erneuert",
  "platform.auditAction.Tenant.SecurityIncidentNotified": "Sicherheitsvorfall gemeldet",
  "platform.auditAction.Tenant.TrialExtended": "Testphase verlängert",
  "platform.auditAction.Onboarding.Started": "Anlegen begonnen",
  "platform.auditAction.Onboarding.OrganizationCreated": "Organisation im Anmeldedienst angelegt",
  "platform.auditAction.Onboarding.AdministratorCreated": "Administration angelegt",
  "platform.auditAction.Onboarding.TenantProvisioned": "Mandant mit Betrieb angelegt",
  "platform.auditAction.Onboarding.Registered": "Im Mandantenverzeichnis eingetragen",
  "platform.auditAction.Onboarding.AdministratorAccountCreated":
    "Konto der Administration angelegt",
  "platform.auditAction.Onboarding.InvitationSent": "Einladung gesendet",
  "platform.auditAction.Onboarding.InvitationFailed": "Einladung fehlgeschlagen",
  "platform.auditAction.Onboarding.RolledBack": "Anlegen zurückgenommen",
  "platform.auditAction.Onboarding.RollbackFailed": "Zurücknehmen des Anlegens fehlgeschlagen",
  "platform.auditAction.Plan.VersionCreated": "Planversion angelegt",
  "platform.auditAction.Invoice.Issued": "Rechnung ausgestellt",
  "platform.auditAction.Invoice.CreditNoteIssued": "Gutschrift ausgestellt",
  "platform.auditAction.Payment.CustomerCreated": "Kunde beim Zahlungsanbieter angelegt",
  "platform.auditAction.Payment.Mirrored": "Zahlungsstand übernommen",
  "platform.auditAction.Payment.Mismatch": "Abweichung beim Zahlungsabgleich",
  "platform.auditAction.Payment.UsageReported":
    "Aktive Beschäftigte an den Zahlungsdienst gemeldet",
  "platform.auditDetail.Status": "Status",
  "platform.auditDetail.PlanId": "Plan-ID",
  "platform.auditDetail.PlanCode": "Plan",
  "platform.auditDetail.Isolation": "Datenhaltung",
  "platform.auditDetail.DatabaseKey": "Datenbank",
  "platform.auditDetail.ProtectionNeed": "Schutzbedarf",
  "platform.auditDetail.Step": "Schritt",
  "platform.auditDetail.Kind": "Art",
  "platform.auditDetail.Number": "Nummer",
  "platform.auditDetail.NetCents": "Netto (Cent)",
  "platform.auditDetail.TaxCents": "Umsatzsteuer (Cent)",
  "platform.auditDetail.GrossCents": "Brutto (Cent)",
  "platform.auditDetail.TaxTreatment": "Steuerliche Behandlung",
  "platform.auditDetail.Protocol": "Protokoll",
  "platform.auditDetail.Changed": "Geändert",
  "platform.auditDetail.Month": "Monat",
  "platform.auditDetail.Quantity": "Menge",
  "platform.auditDetail.PaymentMethod": "Zahlungsart",
  "platform.auditDetail.DetectedAt": "Festgestellt am",
  "platform.auditDetail.PreviousTrialEndsOn": "Bisheriges Ende der Testphase",
  "platform.auditDetail.TrialEndsOn": "Ende der Testphase",
  "platform.auditDetail.TrialExtensions": "Verlängerungen",
  "platform.auditDetail.Comment": "Begründung",
  "platform.auditDetail.Name": "Name",
  "platform.auditDetail.IsPublic": "Öffentlich buchbar",
  "platform.auditDetail.ValidFrom": "Gültig ab",
  "platform.auditDetail.BasePriceCents": "Grundpreis (Cent)",
  "platform.auditDetail.PricePerActiveEmployeeCents": "Preis je aktiver Person (Cent)",
  "platform.auditDetail.Currency": "Währung",
  "platform.auditDetail.EmployeeLimit": "Enthaltene Personen",
  "platform.auditDetail.Entitlements": "Funktionen",
  "platform.jobKind.PublicApiWebhooks": "Webhooks der öffentlichen API",
  "platform.jobKind.NightlyCompliance": "Nächtliche Regelprüfung",
  "platform.jobKind.RecordingReminders": "Erinnerungen ans Erfassen",
  "platform.jobKind.AuditAnchor": "Verankerung des Prüfprotokolls",
  "platform.jobKind.Retention": "Löschfristen",
  "platform.jobKind.UsageMetering": "Nutzungszählung",
  "platform.jobKind.DataEncryption": "Verschlüsselung der Daten",
  "platform.jobKind.ProjectAttributionReminders": "Erinnerungen an die Projektzuordnung",
  "platform.jobKind.TenantDataExport": "Datenexport des Mandanten",
  "platform.jobKind.LeaveNotices": "Hinweise zum Urlaub",
  "platform.jobKind.AbsenceNotifications": "Benachrichtigungen zu Abwesenheiten",
  "platform.jobKind.RosterNotifications": "Benachrichtigungen zum Dienstplan",
  "platform.jobKind.ProjectBudgetAlerts": "Warnungen zu Projektbudgets",
  "platform.worker.PlatformWorker": "Plattform (Status, Mahnungen, Fristen, Löschungen)",
  "platform.worker.EmailOutboxWorker": "E-Mail-Versand",
  // F-86: steps of the platform run, new audit keys and known detail values (ADR-0210).
  "platform.system.steps": "Schritte: {worker}",
  "platform.system.stepsIntro":
    "Schlägt ein Schritt fehl, laufen die anderen Schritte weiter; nur Schritte, die ihn brauchen, werden übersprungen und laufen erst im nächsten Lauf.",
  "platform.system.step": "Schritt",
  "platform.system.stepResult": "Im letzten Lauf",
  "platform.workerStep.SubscriptionSync": "Plan und Leistungsstand übernehmen",
  "platform.workerStep.ExportWindow": "Exportfristen öffnen, Hinweise senden",
  "platform.workerStep.Offboarding": "Mandanten nach der Exportfrist löschen",
  "platform.workerStep.SubprocessorNotices": "Hinweise zu Unterauftragsverarbeitern senden",
  "platform.workerStep.Dunning": "Mahnungen und Sperren",
  "platform.workerStep.TrialReminders": "Erinnerungen vor Ende der Testphase",
  "platform.workerStep.UnfinishedSignups": "Unvollständige Registrierungen löschen",
  "platform.workerStep.AuditRetention": "Plattform-Protokoll nach Ablauf der Frist löschen",
  "platform.workerStepResult.Succeeded": "Erfolgreich",
  "platform.workerStepResult.Failed": "Fehlgeschlagen",
  "platform.workerStepResult.NotRun": "Nicht ausgeführt",
  "platform.workerStepResult.Skipped": "Übersprungen",
  "platform.auditDetail.Rows": "Gelöschte Datensätze",
  "platform.auditDetail.PendingAccounts": "Noch offene Konten",
  "platform.auditDetail.Deleted": "Gelöschte Konten",
  "platform.auditDetail.KeptAccounts": "Behaltene Konten",
  "platform.auditDetail.Organization": "Organisation im Anmeldedienst",
  "platform.auditDetail.Reason": "Grund",
  "platform.auditDetail.DeleteAfter": "Löschung ab",
  "platform.auditDetail.Version": "Schlüsselversion",
  "platform.auditDetail.Resealed": "Neu verschlüsselte Schlüssel",
  "platform.auditDetail.MovingToDatabaseKey": "Zieldatenbank",
  "platform.auditDetail.CorrectedInvoiceNumber": "Korrigierte Rechnung",
  "platform.auditValue.true": "Ja",
  "platform.auditValue.false": "Nein",
  "platform.auditValue.Kind.Invoice": "Rechnung",
  "platform.auditValue.Kind.CreditNote": "Gutschrift",
  "platform.auditValue.Kind.Opened": "Exportfrist geöffnet",
  "platform.auditValue.Kind.Closing": "Exportfrist endet bald",
  "platform.auditValue.TaxTreatment.Domestic19": "Inland, 19 % Umsatzsteuer",
  "platform.auditValue.TaxTreatment.ReverseChargeEu":
    "Steuerschuldnerschaft des Leistungsempfängers (EU)",
  "platform.auditValue.Reason.Reactivated": "Reaktiviert",
  "error.TT-3500":
    "Der Mandant ist nicht in der Testphase. Nur eine laufende Testphase lässt sich verlängern.",
  "error.TT-3501":
    "Dieser Tag ist nicht erlaubt: Das neue Ende muss nach dem bisherigen Ende liegen, darf nicht vor heute liegen und nicht nach dem spätesten Ende.",
  "error.TT-3502": "Die Testphase wurde bereits so oft verlängert wie erlaubt.",
  "error.TT-3503":
    "Die Version muss nach heute und nach der letzten Version des Plans beginnen. Gespeicherte Versionen bleiben unverändert.",
  "error.TT-3504":
    "Die Betriebskonten lassen sich nicht anzeigen: Die Verwaltung des Anmeldedienstes ist im Betrieb nicht eingerichtet.",
  "error.TT-3505":
    "Der Anmeldedienst hat die Liste der Betriebskonten verweigert oder nicht beantwortet. Prüfen Sie die Rolle „view-realm“ des Dienstkontos.",
  "error.TT-3506":
    "Die neue Version enthält weniger Funktionen oder weniger Beschäftigte als die letzte Version des Plans. Legen Sie für einen kleineren Umfang einen neuen Plan mit eigenem Code an.",
  "error.TT-3507":
    "Gerade läuft ein Update der Datenbanken. Richten Sie die eigene Datenbank an, wenn es abgeschlossen ist.",
} as const satisfies Record<string, string>;
